import { useCallback, useRef, useEffect } from 'react';

export const useClickOutSide = (onClose, isActive) => {
  const innerSideRef = useRef(null);
  const clickOutSideHandler = useCallback(
    (e) => {
      if (innerSideRef && innerSideRef.current?.contains(e.target)) return;
      onClose();
    },
    [onClose]
  );
  useEffect(() => {
    if (isActive) {
      document.addEventListener('click', clickOutSideHandler);
    } else {
      document.removeEventListener('click', clickOutSideHandler);
    }
  }, [isActive]);
  return [innerSideRef];
};
